import { useTranslation } from 'react-i18next';
import { MOD_KEY } from '@/lib/platform';

/**
 * Live cheat-sheet of all keyboard shortcuts. Presented as a static list
 * inside the settings flow so users don't have to discover Cmd+/ to learn
 * which keys exist.
 */
export function ShortcutsTab() {
  const { t } = useTranslation();
  const mod = MOD_KEY;
  const shortcuts: Array<{ keys: string; label: string }> = [
    { keys: `${mod}+K`, label: t('set2.shortcuts.quickSwitch') },
    { keys: 'J', label: t('set2.shortcuts.nextMention') },
    { keys: `${mod}+/`, label: t('set2.shortcuts.cheatSheet') },
    { keys: `${mod}+B`, label: t('set2.shortcuts.bold') },
    { keys: `${mod}+I`, label: t('set2.shortcuts.italic') },
    { keys: `${mod}+E`, label: t('set2.shortcuts.inlineCode') },
    { keys: `${mod}+Shift+X`, label: t('set2.shortcuts.strikethrough') },
    { keys: `${mod}+Shift+.`, label: t('set2.shortcuts.spoiler') },
    { keys: '↑', label: t('set2.shortcuts.editLast') },
    { keys: `${mod}+Shift+K`, label: t('set2.shortcuts.link') },
    { keys: 'Enter', label: t('set2.shortcuts.send') },
    { keys: 'Shift+Enter', label: t('set2.shortcuts.newline') },
    { keys: 'Esc', label: t('set2.shortcuts.escape') },
    { keys: '@', label: t('set2.shortcuts.mention') },
  ];
  return (
    <div className="app-settings-card app-settings-shortcuts flex flex-col">
      {shortcuts.map((s) => (
        <div
          key={s.label}
          className="flex items-center justify-between gap-4 py-2.5"
        >
          <span className="min-w-0 text-sm text-ink">{s.label}</span>
          <kbd className="shrink-0 rounded-lg bg-default px-2 py-1 font-mono text-xs text-ink-dim">
            {s.keys}
          </kbd>
        </div>
      ))}
    </div>
  );
}
